import { useMutation } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Fragment } from 'react';

import { CreateStationForm } from '@/components/management/form/CreateStationForm';
import { FormGridLayout } from '@/components/management/form/formHelpers/FormGridLayout';
import { AdministrationBody } from '@/components/management/layout/AdministrationBody';
import { AdministrationHeader } from '@/components/management/layout/AdministrationHeader';
import { useScrollSpy } from '@/hooks/useScrollSpy';
import { backendApiStationsCreateMutation } from '@/modules/api/backend/@tanstack/react-query.gen';
import { useSnackbarStore } from '@/stores/useSnackbarStore';

export const Route = createFileRoute('/_authenticated/management/stations/create')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
  beforeLoad: async () => ({ breadcrumb: 'Neue Station' }),
});

function RouteComponent() {
  const navigate = Route.useNavigate();

  const { openSnackbar } = useSnackbarStore((state) => state.actions);

  const { mutateAsync } = useMutation({
    ...backendApiStationsCreateMutation(),
    onSuccess: (station) => {
      navigate({ to: '/management/stations/$stationId', params: { stationId: station.id }, ignoreBlocker: true });
      openSnackbar({
        color: 'success',
        message: 'Die Station wurde erfolgreich erstellt!',
      });
    },
    onError: () => {
      openSnackbar({
        color: 'error',
        message: 'Fehler beim Erstellen der Station.',
      });
    },
  });

  const tabs = ['Station'];
  const { setRef, scrollTo, activeIndex } = useScrollSpy<HTMLDivElement>(tabs.length);

  return (
    <Fragment>
      <AdministrationHeader formId="stationForm" label="Station erstellen" />
      <AdministrationBody>
        <FormGridLayout activeTab={activeIndex} onTabChange={scrollTo} tabs={tabs}>
          <CreateStationForm
            setRef={setRef}
            tabs={tabs}
            onSubmit={async (values) => {
              await mutateAsync({ body: values });
            }}
          />
        </FormGridLayout>
      </AdministrationBody>
    </Fragment>
  );
}
